module.exports = __webpack_public_path__ + "static/media/subscription_preview.da1ad7dd.PNG";